import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useToast } from "@/hooks/use-toast";
import { apiRequest } from "@/lib/queryClient";
import { SENHA_MINIMA } from "@shared/schema";

/** "Trocar minha senha" — qualquer papel, do rodapé do menu. Não desloga quem trocou. */
export function TrocarSenhaDialog({ aberto, onFechar }: { aberto: boolean; onFechar: () => void }) {
  const { toast } = useToast();
  const [atual, setAtual] = useState("");
  const [nova, setNova] = useState("");
  const [confirma, setConfirma] = useState("");
  const [salvando, setSalvando] = useState(false);

  const invalida = nova.length < SENHA_MINIMA || nova !== confirma || !atual;

  async function salvar() {
    setSalvando(true);
    try {
      await apiRequest("POST", "/api/auth/senha", { atual, nova });
      toast({ title: "Senha trocada", description: "As suas outras sessões foram encerradas." });
      setAtual(""); setNova(""); setConfirma("");
      onFechar();
    } catch (e: any) {
      toast({ title: "Não deu para trocar", description: e?.mensagem ?? e?.message ?? "Tente de novo.", variant: "destructive" });
    } finally {
      setSalvando(false);
    }
  }

  return (
    <Dialog open={aberto} onOpenChange={a => { if (!a) onFechar(); }}>
      <DialogContent className="max-w-sm" data-testid="dialog-trocar-senha">
        <DialogHeader>
          <DialogTitle>Trocar minha senha</DialogTitle>
          <DialogDescription>Mínimo de {SENHA_MINIMA} caracteres.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div className="space-y-1">
            <Label htmlFor="senha-atual">Senha atual</Label>
            <Input id="senha-atual" type="password" autoComplete="current-password" value={atual} onChange={e => setAtual(e.target.value)} data-testid="input-senha-atual" />
          </div>
          <div className="space-y-1">
            <Label htmlFor="senha-nova">Nova senha</Label>
            <Input id="senha-nova" type="password" autoComplete="new-password" value={nova} onChange={e => setNova(e.target.value)} data-testid="input-senha-nova" />
          </div>
          <div className="space-y-1">
            <Label htmlFor="senha-confirma">Repita a nova senha</Label>
            <Input id="senha-confirma" type="password" autoComplete="new-password" value={confirma} onChange={e => setConfirma(e.target.value)} data-testid="input-senha-confirma" />
            {confirma && nova !== confirma && <p className="text-xs text-destructive">As senhas não conferem.</p>}
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onFechar}>Cancelar</Button>
          <Button onClick={salvar} disabled={invalida || salvando} data-testid="button-salvar-senha">{salvando ? "Salvando…" : "Trocar senha"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
